import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import Link from 'next/link';
import { white, black, grey60 } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import { fontTitle } from '../../styles/fonts';
import IconOriginal from '../Icons/Icon';
import Button from '../Button/Button';
import ButtonIconOriginal from '../Icons/ButtonIcon';

export const Navigation = styled.div``;

export const NavigationBar = styled.div`
  background-color: ${white};
  display: flex;
  height: 64px;
  align-items: center;
  padding: 0 12px;
  max-width: 1520px;
  margin: 0 auto;

  ${breakpoint('medium')} {
    padding: 0 32px;
  }

  ${breakpoint('large')} {
    padding: 0 32px 0 48px;
  }
`;

export const LogoContainer = styled.div`
  order: 2;
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;

  ${breakpoint('large')} {
    order: 1;
    justify-content: flex-start;
  }
`;

export const LogoLink = styled(Link)`
  text-decoration: none;
`;

export const Icon = styled(IconOriginal)`
  color: ${black};
`;

export const LeftIcons = styled.div`
  flex: 1;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${breakpoint('large')} {
    display: none;
  }
`;

export const RightIcons = styled.div`
  flex: 1;
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  align-items: center;
  order: 3;
`;

export const RightInnerIcons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DesktopLinkContainer = styled.div`
  display: none;

  ${breakpoint('large')} {
    display: flex;
    column-gap: 16px;
    order: 2;
  }
`;

export const NavLink = styled.a`
  ${fontTitle(14)};
  color: ${black};
  text-decoration: none;
  margin: 8px;
  white-space: nowrap;
  border-bottom: ${ifProp(
  { active: true },
  `1px solid ${grey60}`,
  '1px solid transparent'
)};

  &:hover {
    border-bottom: 1px solid ${grey60};
  }
`;

export const BuyAgainLink = styled(NavLink)`
  display: none;

  ${breakpoint('large')} {
    display: block;
  }
`;

export const ButtonIcon = styled(ButtonIconOriginal).attrs({
  variant: 'secondary',
  isGhost: true
})`
  font-weight: normal;
  width: 48px;
`;

export const LeftSearchIcon = styled(ButtonIcon)`
  ${breakpoint('large')} {
    display: none;
  }
`;

export const RightSearchIcon = styled(ButtonIcon)`
  display: none;

  ${breakpoint('large')} {
    display: block;
  }

  &:hover, :focus {
    background-color: transparent;
  }
`;

export const LogInButton = styled(Button)`
  ${fontTitle(14)};
  padding: 0;
  min-width: auto;
  ${breakpoint('medium')} {
    padding-right: 8px;
  }

  &:hover, :focus {
    background-color: transparent;
  }
`;

export default {};
